import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { postFetcher, patchFetcher, patchFetcherWithoutId } from "../services/api";

const useFormatNomorSurat = (mutate) => {
  const [isEdit, setIsEdit] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);

  const { control, handleSubmit, reset, formState } = useForm({
    defaultValues: {
      documentType: "",
      formatNomorSurat: "",
    },
  });

  const onOpenModalForm = () => {
    setIsEdit(false);
    reset({
      documentType: "",
      formatNomorSurat: "",
    });
    setIsOpenModalForm(true);
  };

  const onOpenChangeModalForm = (isOpen) => {
    if (!isOpen) {
      onCloseForm();
    }
  };

  const onCloseForm = () => {
    setIsOpenModalForm(false);
    setIsEdit(false);
    setCurrentData(null);
    reset();
  };

  const onClickEdit = (data) => {
    setIsEdit(true);
    setCurrentData(data);
    reset({
      documentType: data.documentType,
      formatNomorSurat: data.formatNomorSurat,
    });
    setIsOpenModalForm(true);
  };

  const onSubmitForm = async (formData) => {
    try {
      if (isEdit) {
        await patchFetcherWithoutId(`/api/nomor-surat/update`, formData);
        toast.success("Format nomor surat berhasil diperbarui.");
      } else {
        await postFetcher(`/api/nomor-surat/create`, formData);
        toast.success("Format nomor surat berhasil ditambahkan.");
      }
      if (mutate) await mutate(); // Refresh data tabel setelah submit
      onCloseForm();
    } catch (error) {
      toast.error(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };

  return {
    isEdit,
    onClickEdit,
    onCloseForm,
    onSubmitForm,
    modalForm: {
      onOpenModalForm,
      isOpenModalForm,
      onOpenChangeModalForm,
    },
    hookForm: {
      control,
      handleSubmit,
      formState,
    },
  };
};

export default useFormatNomorSurat;
